// extracted by mini-css-extract-plugin
export default {"imageAlt":"Customise_imageAlt__4VNZp","image":"Customise_image__HKHKm","code":"Customise_code__DyxQC"};